<template>
  <main class="main product-list-page page-inside">
    <div class="main-wrapper">
      <section class="section hero-section">
        <div class="wrapper">
          <div class="title">{{ $t(`Prompts`) }}</div>
        </div>
      </section>
      <section class="section product-list-section">
        <div class="wrapper">
          <div class="top">
            <div class="search">
              <input
                  type="text"
                  :placeholder="$t('Type here to search')"
                  v-model="search"
                  @keyup.enter="getProducts"
              />
              <button class="button white" @click="getProducts">
                <img src="./../img/search.svg" class="img"/>
              </button>
            </div>
            <div class="filters">
              <div class="filters-wrapper">
                <div class="select-container" v-if="sortOptions.length">
                  <Select2
                      class="select2"
                      v-model="sort"
                      :options="sortOptions"
                      :placeholder="$t('Sort')"
                      @select="selectSort"
                  />
                </div>
                <div class="select-container" v-if="localCategoryOptions.length">
                  <Select2
                      class="select2 single"
                      v-model="selectedCategory"
                      :options="localCategoryOptions"
                      :placeholder="$t('Topic')"
                      @select="onSelectCategory"
                  />
                </div>
                <!--
                <div class="select-container" v-if="categoryOptions2Local.length">
                  <Select2
                    class="select2 single"
                    v-model="selectedCategory2"
                    :options="categoryOptions2Local"
                    :placeholder="$t('Categories')"
                    @select="onSelectCategory2"
                  />
                </div>
                -->
                <div class="select-container" v-if="localModelOptions && localModelOptions.length > 1">
                  <Select2
                      class="select2 single"
                      v-model="selectedModel"
                      :options="localModelOptions"
                      :placeholder="$t('Model')"
                      @select="onSelectModel"
                  />
                </div>
                <button class="button" @click="getProducts">{{ $t(`Apply`) }}</button>
              </div>
            </div>
          </div>
          <transition name="fade">
            <div class="list products" v-if="productList">
              <div class="item" v-for="(item, i) in productList" :key="i">
                <ProductCard
                    :models="localModelOptions"
                    :tag="item.parent_cat_id"
                    :item="item"
                    :sliderIsClickble="true"
                    @goToProduct="goToProduct"
                    @openReadyModal="(itemType, product) => $emit('openReadyModal', itemType, product)"
                    @openSignInModal="() => $emit('openSignInModal')"
                    :currency="currency"
                />
              </div>
              <div class="title no-products" v-if="!productList.length">{{ $t(`No products!`) }}</div>
            </div>
          </transition>
        </div>
      </section>
    </div>
  </main>
</template>


<script>
import { defineComponent } from 'vue';

import Select2 from 'vue3-select2-component';
import ProductCard from '../components/ProductCard.vue';

export default defineComponent({
  emits: ['openReadyModal', 'openSignInModal', 'goToProduct'],
  name: 'ProductList',
  props: ['currency'],

  components: {
    Select2,
    ProductCard
  },

  data() {
    return {
      imgDomain: '',
      sort: '',
      localCategoryOptions: [],   // переименовал
      categoryOptions2Local: [],  // переименовал
      localModelOptions: [],      // переименовал
      selectedModel: '',          // переименовал activeModel
      selectedCategory: '',       // переименовал activeCategory
      selectedCategory2: '',      // переименовал activeCategory2
      productList: [],
      search: '',
      sortOptions: [
        { id: 'desc', text: 'Highest price first' },
        { id: 'asc', text:'Lowest price first' }
      ],
    }
  },

  watch: {
    currency() {
      this.getProducts();
    }
  },

  inject: ['activeCategory', 'activeCategory2', 'activeModel', 'clearSearch'],

  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
    this.getProducts();
    this.getModels();
    this.getCategories();
    this.getCategories2();
  },

  methods: {
    openReadyModal(item, product) {
      this.$emit('openReadyModal', item, product);
    },
    openSignInModal() {
      this.$emit('openSignInModal');
    },
    getModels() {
      this.$http.get( 'categories')
          .then((res) => {
            const newCategories = res.data.payload.filter(item => item.parent_id === null);
            this.localModelOptions = newCategories.map(({id, title: text, url}) => ({ id, text, url }));
            this.localModelOptions.unshift({id: 0, text: 'All', url: ''});
          })
          .catch(() => {});
    },
    getCategories() {
      this.$http.get( 'categories')
          .then((res) => {
            const newCategories = res.data.payload.filter(item => item.parent_id !== null);
            this.localCategoryOptions = newCategories.map(({id, title: text, url}) => ({ id, text, url }));
            this.localCategoryOptions = this.removeIdenticalObjects(this.localCategoryOptions);
            this.localCategoryOptions.unshift({id: 0, text: 'All', url: ''});
          })
          .catch(() => {});
    },
    getCategories2() {
      this.$http.get( 'categories')
          .then((res) => {
            const newCategories = res.data.payload.filter(item => item.parent_id !== null);
            this.categoryOptions2Local = newCategories.map(({id, title: text, url}) => ({ id, text, url }));
            this.categoryOptions2Local = this.removeIdenticalObjects(this.categoryOptions2Local);
            this.categoryOptions2Local.unshift({id: 0, text: 'All', url: ''});
          })
          .catch(() => {});
    },
    removeIdenticalObjects(arr) {
      return arr.filter((item, index) => {
        const firstIndex = arr.findIndex(el => el.text === item.text);
        return index === firstIndex;
      });
    },
    getProducts() {
      // Используем injected значения для фильтрации, локальные обновляем для отражения UI, если нужно
      if (this.activeModel || this.activeCategory || this.activeCategory2) {
        this.selectedModel = this.activeModel;
        this.selectedCategory = this.activeCategory;
        this.selectedCategory2 = this.activeCategory2;
      }

      let addCategory = '';
      if (this.selectedCategory != 'All' && this.selectedCategory !== 0 && this.selectedCategory !== '') {
        addCategory = 'category_id=' + this.selectedCategory;
      }

      let addModel = '';
      if (this.selectedModel != 'All' && this.selectedModel !== 0 && this.selectedModel !== '') {
        addModel = '&model_id=' + this.selectedModel;
      }

      let addSearch = '';
      if (this.search) {
        addSearch = '&search=' + encodeURIComponent(this.search);
      }

      let addSort = '&sort=' + this.sort;

      const url =  'products/catalog?' + addCategory + addModel + addSort + addSearch;

      this.$http.get(url)
          .then((res) => {
            if (this.activeModel || this.activeCategory || this.activeCategory2) {
              this.clearSearch();
            }
            this.productList = res.data.payload;
            if (res.data.meta && res.data.meta.total) {
              this.totalProducts = res.data.meta.total;
            }
          });
    },
    onSelectCategory(event) {
      this.selectedCategory = event.id;
    },
    onSelectCategory2(event) {
      this.selectedCategory2 = event.id;
    },
    onSelectModel(event) {
      this.selectedModel = event.id;
    },
    selectSort(event) {
      this.sort = event.id;
    },
    goToProduct(item) {
      this.$emit('goToProduct', item);
    }
  },
});
</script>
